module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon3.65d58d167edc0dd8e6fb2abd058d0368.png";